import { __assign, __extends } from "tslib";
import * as React from 'react';
import { BaseTableHeadCell } from '../base-table-head-cell/base-table-head-cell';
import { isPromise } from '../../../../common';
import { Icon } from '../../../icon/icon';
import { EllipsisText } from '../../../../composites/ellipsis-text/ellipsis-text';
import * as classNames from 'classnames';
import { directionArrowDown } from '../../../..';
import { InfoTooltip } from '../../../info-tooltip/info-tooltip';
var SortableTableHeadCell = /** @class */ (function (_super) {
    __extends(SortableTableHeadCell, _super);
    function SortableTableHeadCell() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isLoading: false
        };
        _this.stopLoading = function () { return _this.setState({ isLoading: false }); };
        _this.startLoading = function () { return _this.setState({ isLoading: true }); };
        _this.handleSort = function () {
            var currentOrder = _this.props.sortOrder;
            var newOrder = currentOrder === 'asc' ? 'desc' : currentOrder === 'desc' ? 'asc' : 'desc';
            var maybePromise = _this.props.onSortOrderChange ? _this.props.onSortOrderChange(newOrder) : null;
            if (maybePromise && isPromise(maybePromise)) {
                _this.startLoading();
                maybePromise.then(_this.stopLoading, _this.stopLoading);
            }
        };
        return _this;
    }
    SortableTableHeadCell.prototype.render = function () {
        var _a = this, props = _a.props, state = _a.state;
        var isLoading = state.isLoading;
        var sortOrder = "" + props.sortOrder;
        var isDisabled = props.onSortOrderChange ? '' : 'disabled';
        var handleSort = props.onSortOrderChange ? { onClick: this.handleSort } : {};
        var cn = classNames('sortable', sortOrder, props.className, isDisabled, { 'is-loading': isLoading });
        return (React.createElement(BaseTableHeadCell, __assign({ className: cn }, handleSort, { disabled: props.disabled }),
            React.createElement(EllipsisText, null,
                React.createElement("div", { className: 'head-cell-content' }, props.children)),
            this.props.infoIcon ? React.createElement(InfoTooltip, { tooltipAlign: 'left', className: 'head-cell-info', text: this.props.infoIcon }) : null,
            React.createElement(Icon, { className: 'sort-arrow', icon: directionArrowDown })));
    };
    return SortableTableHeadCell;
}(React.PureComponent));
export { SortableTableHeadCell };
//# sourceMappingURL=sortable-table-head-cell.js.map